import { withHandlers } from 'recompose'

export const normalizeEvents = WrappedComponent => withHandlers<any, any>({
  onChange: ({ input: { onChange } }) => ({ name, value }) => onChange(value),
  onBlur: ({ input: { onBlur } }) => () => onBlur(),
})(WrappedComponent)
